import { Skeleton } from "@mui/material";

interface SkeletonLoaderProps {
  count?: number;
  height?: number;
}

export const SkeletonLoader = ({ count = 3, height = 30 }: SkeletonLoaderProps) => (
  <>
    {Array.from({ length: count }).map((_, index) => (
      <Skeleton key={index} variant="text" height={height} />
    ))}
  </>
);
